import type { AnalyticsEvent } from 'Services/analytics/analytics.types';
import { triggerSectionLinksClickedEvent } from 'Services/analytics/events';
import { useSetActiveSection } from 'Stores/VehicleDetailsPositionStore/VehicleDetailsPositionStore';

export type UseOnNavigateToSectionClick = (id: string, label: string) => void;

export const SET_ACTIVE_SECTION_AFTER_SCROLL_DELAY = 50;

interface UseOnNavigateToSectionClickProps {
	analytics: AnalyticsEvent;
	onNavigate?: () => void;
	source: string;
}

export const useOnNavigateToSectionClick = ({
	analytics,
	onNavigate,
	source,
}: UseOnNavigateToSectionClickProps): UseOnNavigateToSectionClick => {
	const setActiveSection = useSetActiveSection();

	const scrollToElement = (id: string) => {
		document?.getElementById(id)?.scrollIntoView();
	};

	return (id, label) => {
		triggerSectionLinksClickedEvent({ category: analytics.category, label, source });
		onNavigate?.();
		scrollToElement(id);
		setTimeout(() => {
			setActiveSection(id);
		}, SET_ACTIVE_SECTION_AFTER_SCROLL_DELAY);
	};
};
